import ListBaladiyaAppliedList from "./ListBaladiyaAppliedList";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBaladiyaData } from "../../../../../store/Api";

export default function BaladiyaAppliedList() {
  const data = useSelector((state) => state.baladiyaData);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  useEffect(() => {
    dispatch(getBaladiyaData(token));
  }, []);

  const updateData = () => {
    dispatch(getBaladiyaData(token));
  };
  console.log("Baladiya tab 2 data to be seen in console",data)
  return (
    <>
      <ListBaladiyaAppliedList
        titles={[
          "SR.NO.",
          "EMPLOYEE ID",
          "EMPLOYEE NAME",
          "Actual Profession",
          "IQAMA Profession",
          "visa Provider",
          "Sponser Id",
          "Client",
          "IQAMA Number",
          "Baladiya LOCATION",
          "Baladiya APPLY DATE",
          "Baladiya ISSUE DATE",
          "Baladiya EXPIRE DATE DATE",
          "Baladiya VALID DAYS",
          "STATUS",
          "",
        ]}
        list={data}
        loading={loading}
        token={token}
        updateData={updateData}
        uploadFile={""}
      />
    </>
  );
}
